<template>
  <PaymentDetail
    :s-payment-id="$route.params.idPayment"
    @back="$router.go(-1)"
  />
</template>

<script>
import PaymentDetail from "./PaymentDetail.vue";

export default {
  name: "PaymentView",
  components: {
    PaymentDetail,
  },
};
</script>
